import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="operating-hours"
export default class extends Controller {
  static targets = ["dayToggle", "timeInputs", "closedBadge", "openTime", "closeTime"]

  connect() {
    // Initialize state based on current checkbox values
    this.dayToggleTargets.forEach(checkbox => {
      this.updateDayState(checkbox)
    })
  }

  toggleDay(event) {
    this.updateDayState(event.target)
  }

  updateDayState(checkbox) {
    const day = checkbox.dataset.day
    const container = this.element.querySelector(`[data-day="${day}"]`)
    if (!container) return

    const timeInputs = container.querySelectorAll('input[type="time"]')
    const closedBadge = container.querySelector('[data-operating-hours-target="closedBadge"]')

    timeInputs.forEach(input => {
      input.disabled = !checkbox.checked
    })

    if (closedBadge) {
      closedBadge.style.display = checkbox.checked ? 'none' : 'flex'
    }
  }

  setWeekdays() {
    const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
    this.enableDays(weekdays)
  }

  setWeekends() {
    const weekends = ['saturday', 'sunday']
    this.enableDays(weekends)
  }

  setAllDays() {
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
    this.enableDays(days)
  }

  clearAll() {
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
    days.forEach(day => {
      const checkbox = this.element.querySelector(`input[data-day="${day}"]`)
      if (checkbox) {
        checkbox.checked = false
        this.updateDayState(checkbox)
      }
    })
  }

  enableDays(days) {
    days.forEach(day => {
      const checkbox = this.element.querySelector(`input[data-day="${day}"]`)
      if (checkbox) {
        checkbox.checked = true
        this.updateDayState(checkbox)
      }
    })
  }

  applyTemplate(event) {
    const template = event.currentTarget.dataset.template
    const templates = {
      'early-bird': {
        weekdays: { open: '05:00', close: '22:00' },
        weekends: { open: '07:00', close: '18:00' }
      },
      'standard': {
        weekdays: { open: '06:00', close: '22:00' },
        weekends: { open: '08:00', close: '20:00' }
      },
      'late-night': {
        weekdays: { open: '05:00', close: '23:00' },
        weekends: { open: '07:00', close: '21:00' }
      },
      '24-7': {
        weekdays: { open: '00:00', close: '23:59' },
        weekends: { open: '00:00', close: '23:59' }
      }
    }

    const config = templates[template]
    if (!config) return

    const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday']
    const weekends = ['saturday', 'sunday']

    weekdays.forEach(day => {
      this.applyDayConfig(day, config.weekdays)
    })

    weekends.forEach(day => {
      this.applyDayConfig(day, config.weekends)
    })
  }

  applyDayConfig(day, config) {
    const checkbox = this.element.querySelector(`input[data-day="${day}"]`)
    const openTime = this.element.querySelector(`input[name="location[operating_hours][${day}][open_time]"]`)
    const closeTime = this.element.querySelector(`input[name="location[operating_hours][${day}][close_time]"]`)

    if (checkbox) checkbox.checked = true
    if (openTime) openTime.value = config.open
    if (closeTime) closeTime.value = config.close

    if (checkbox) this.updateDayState(checkbox)
  }
}
